import { useI18n } from 'hooks/useI18n';
import { WebOffer } from 'model/model.web-offer';
import { withTranslation } from 'next-i18next';
import Head from 'next/head';
import {
  getOfferOGDescription,
  getOfferOGTitle
} from 'services/ui/offer-og.service';
import { getCanonicalUrl } from 'services/ui/offer.service';
import { AppUrlPath } from 'utils/app-urls';
import { config } from 'utils/config';
import JobOfferJobPostingSchema from './JobOfferJobPostingSchema';

type JobOfferPageHeadProps = {
  offer: WebOffer;
  url: AppUrlPath;
  locale?: string;
  origin: string;
  preview?: boolean;
};

const JobOfferPageHead: React.FC<JobOfferPageHeadProps> = ({
  offer,
  locale,
  origin,
  preview,
  url
}) => {
  const { t } = useI18n('job-offer');

  return (
    <>
      <Head>
        <title>
          {preview ? '[PREVIEW] ' : ''}
          {getOfferOGTitle(offer, t, locale)}
        </title>

        <link rel="canonical" href={getCanonicalUrl(origin, offer, locale)} />

        <meta property="og:title" content={getOfferOGTitle(offer, t, locale)} />
        <meta
          property="og:image"
          content={offer.heroSectionData.companyPhoto}
        />
        <meta
          property="og:url"
          content={getCanonicalUrl(origin, offer, locale)}
        />
        <meta
          property="og:description"
          content={getOfferOGDescription(offer, t, locale)}
        />
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta name="twitter:site" content="@getmanfred"></meta>
        <meta name="twitter:creator" content="@getmanfred"></meta>
        <meta
          name="twitter:title"
          content={getOfferOGTitle(offer, t, locale)}
        ></meta>
        <meta
          name="twitter:description"
          content={getOfferOGDescription(offer, t, locale)}
        ></meta>
        <meta
          name="twitter:image"
          content={offer.heroSectionData.companyPhoto}
        ></meta>

        <meta name="robots" content="index,follow" />

        {Object.keys(url.langs).map((key) => {
          return (
            <link
              key={key}
              rel="alternate"
              hrefLang={key}
              href={`${config.appUrl}${url.langs[key]}/${offer.id}/${offer.slug}`}
            />
          );
        })}
      </Head>

      <JobOfferJobPostingSchema offer={offer} locale={locale} />
    </>
  );
};

export default withTranslation(['common', 'job-offer', 'topbar', 'footer'])(
  JobOfferPageHead
);
